// Lia Vigia: painel do que ficou para trás.
import { frontendURL } from '../../../helper/URLHelper';

const VigiaIndex = () => import('./VigiaIndex.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/vigia'),
    name: 'vigia_index',
    meta: { permissions: ['administrator', 'agent'] },
    component: VigiaIndex,
  },
];
